import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root'
})
export class InventoryCategoryService {
  public mtds: Methods = new Methods();
  public url: string;
  public token;


  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + '/inventorycategory/';
  }

  save(json): Observable<any> {
    if (json.id === null) {
      return this.create(json);
    } else {
      return this.update(json, json.id);
    }
  }

  create(json): Observable<any> {
    return this.petition(this.url + 'new', json);
  }

  update(json, id): Observable<any> {
    return this.petition(this.url + 'edit/' + id, json);
  }

  showOne(id): Observable<any> {
    return this.petition(this.url + 'detail/' + id);
  }

  showAll(father = 0, level = null): Observable<any> {
    let params = {"level": level}
   

    return this.petition(this.url + 'listbylevel/' + father, params);
  }

  delete(id): Observable<any> {
    return this.petition(this.url + 'remove/' + id);
  }

  petition(url, json = null): Observable<any> {
   

    this.token = JSON.parse(localStorage.getItem('token'));
     let params = new HttpParams().set('authorization', this.token);
     if (json != null) {
      //json = encodeURIComponent(JSON.stringify(json));
      json = JSON.stringify(json);
      params = params.set('json', json);
    }
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post(url, params, { headers: headers })
      .pipe(
        map(res => res),
        catchError(error => {
          if (error.status === 400 && error.error.msg === 'Authorization not valid') {
            this.mtds.notifyError('Your session has expired');
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
          throw error;
        })
      );
  }
}
